export const API_CONFIG = {
  BASE_URL: `${import.meta.env.VITE_API_URL || 'http://localhost:8080'}/api`,  // Correction de l'interpolation de chaîne
  AUTH: {
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
  },
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000,
  },
  TIMEOUT: 30000,
} as const;

// Log pour déboguer les URLs
console.log('API CONFIG BASE_URL:', API_CONFIG.BASE_URL);